import cx from "classnames"
import * as React from "react"
import * as styles from "./styles.module.scss"
import LinkUnderline from "components/LinkUnderline"

export interface DropdownRatesPurchaseProps {
  linkClass: string
}

const DropdownRatesPurchase: React.FC<DropdownRatesPurchaseProps> = ({
  linkClass,
}) => {
  return (
    <div
      className={cx({
        [styles.dropdown]: true,
        [styles.dropdownHover]: true,
        [styles.dropdownRates]: true,
      })}
    >
      <div
        className={cx({
          [linkClass]: true,
          [styles.toggle]: true,
        })}
      >
        <LinkUnderline>Rates</LinkUnderline>
      </div>
      <div className={styles.menu}>
        <div className={styles.shadow}>
          <div className={styles.navbar}>
            <div className={styles.navbarLinks}>
              <div className={styles.navbarLink}>
                <span className={styles.navbarLinkText}>Purchase</span>
              </div>
              <div className={styles.navbarLink}>
                <span className={styles.navbarLinkText}>Refinance</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default DropdownRatesPurchase
